module.exports = __webpack_public_path__ + "img/door-contact-md.c0dd7d84.svg";